import './index.css'

import React, { Component } from 'react'

import { nanoid } from 'nanoid'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import LabelMessage from '../utils/label-message'

class DropDownComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      field: this.props.field,
      label: this.props.label,
      value: this.props.value,
      options: this.props.options,
      onFocus: false,
      id: nanoid(),
    }
  }

  onFocus = e => {
    this.setState({ onFocus: !this.state.onFocus })
  }

  onBlur = e => {
    this.setState({ onFocus: false })
  }

  onClick = e => {
    const value = e.target.getAttribute('value')
    this.setState({ value })
    this.props.update(this.state.field, value)
  }

  showArrow = () => {
    let showArrow = <FontAwesomeIcon icon={faChevronDown} />
    if (this.state.onFocus) showArrow = <FontAwesomeIcon icon={faChevronUp} />

    return showArrow
  }

  render() {
    return (
      <div className="text-input" tabIndex={0} onClick={this.onFocus} onBlur={this.onBlur}>
        <LabelMessage label={this.state.label} />

        <div className="drop-down-content">
          <div className="drop-down">
            <div>{this.state.value}</div>
            <div className="drop-down-arrow">{this.showArrow()}</div>
          </div>

          <div className={`text-input-border-bottom ${this.state.onFocus ? 'active' : ''}`} />

          <div className={`drop-down-list ${this.state.onFocus ? 'active' : 'disable'}`}>
            <ul>
              <li key={nanoid()}>
                <div
                  onClick={this.onClick}
                  value=""
                  className={`drop-down-list-option ${this.state.value === '' ? 'selected' : ''}`}
                >
                  Don't show level
                </div>
              </li>
              {this.state.options.map((element, index) => {
                return (
                  <li key={nanoid()}>
                    <div
                      onClick={this.onClick}
                      value={element}
                      className={`drop-down-list-option ${
                        this.state.value === element ? 'selected' : ''
                      }`}
                    >
                      {element}
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

const defaultOptions = [
  'Native Speaker',
  'Highly Proficient',
  'Very Good Command',
  'Good Working Knowledge',
  'Working Knowledge',
  'C2',
  'C1',
  'B2',
  'B1',
  'A2',
  'A1',
]

DropDownComponent.propTypes = {}
DropDownComponent.defaultProps = { field: 'field', value: 'Default', options: defaultOptions }

export default DropDownComponent
